import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { useReducedMotion } from "@/hooks/use-reduced-motion";

interface BookmarkHintBubbleProps {
  show: boolean;
  onDismiss: () => void;
}

export function BookmarkHintBubble({ show, onDismiss }: BookmarkHintBubbleProps) {
  const isReduced = useReducedMotion();

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="bookmark-hint"
          initial={isReduced ? false : { opacity: 0, y: -6, scale: 0.97 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={isReduced ? { opacity: 0 } : { opacity: 0, y: -4, scale: 0.97 }}
          transition={{ duration: 0.2, ease: "easeOut" }}
          className="absolute top-10 right-0 z-20 w-52"
          onClick={(e) => e.stopPropagation()}
        >
          <div
            className="absolute -top-2 right-[6px] w-0 h-0"
            style={{
              borderLeft: "8px solid transparent",
              borderRight: "8px solid transparent",
              borderBottom: "8px solid #3b82f6",
            }}
          />
          <div
            className="relative rounded-lg border bg-zinc-950 p-3 pr-9 shadow-xl shadow-black/50 font-sans"
            style={{ borderColor: "#3b82f6" }}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDismiss();
              }}
              aria-label="Dismiss bookmark hint"
              className="absolute top-2 right-2 p-1 rounded text-zinc-400 hover:text-white transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
            <div className="text-sm leading-snug text-zinc-200">
              <p className="font-semibold text-white mb-1">Save profiles</p>
              <p>Bookmark anyone you want to revisit — find them all on your Saved Profiles page under the account menu.</p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
